import React, { useState } from "react";
import s from "./style.module.css";
import { Scrollama, Step } from "react-scrollama";
import { useInView } from "react-intersection-observer";

const Summary = ({ scenes, copy, ...rest }) => {
  const [
    { rotation, fill, stroke = "rgb(0, 0, 0, 0.2)", slide = 0 },
    setVizProps,
  ] = useState(rest);

  const [inViewRef, inView] = useInView({
    triggerOnce: true,
    threshold: 0.4,
    delay: 17,
  });

  return (
    <div
      className={s.full}
      style={{
        "--main-rotation": rotation,
        "--fill": fill,
      }}
    >
      <div className={s.wrap}>
        <div className={s.summary}>
          <svg
            ref={inViewRef}
            viewBox="0 0 814 814"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            className={s.svg}
          >
            <g
              id="Page-1"
              stroke="none"
              strokeWidth="1"
              fill="none"
              fillRule="evenodd"
            >
              <g id="image-(29)" transform="translate(1.000000, 1.000000)">
                <path
                  d="M406,0 L55,609 L758,609 L406,0 Z M372,262 L264,449 M549,449 L441,261 M298,509 L514,509"
                  id="Shape"
                  className={s.transition}
                  stroke={stroke}
                  strokeWidth="3"
                  transform={`translate(407, 407) scale(${
                    inView ? 1 : 1
                  }) translate(-407, -407)`}
                ></path>
                <polygon
                  id="Path"
                  className={s.transition}
                  stroke={stroke}
                  strokeWidth="3"
                  points="406 509 495 355 318 355"
                  transform={`translate(407, 407) scale(${
                    inView ? 1 : 1
                  }) translate(-407, -407)`}
                ></polygon>

                <circle
                  id="Oval"
                  className={s.transition}
                  transform={`translate(406.3, 201.8) scale(${
                    inView ? 1 : 1
                  }) translate(-406.3, -201.8)`}
                  stroke={stroke}
                  strokeWidth="3"
                  cx="406.3"
                  cy="201.8"
                  r="100.8"
                ></circle>

                <circle
                  id="Oval"
                  className={s.transition}
                  transform={`translate(494.9, 355.2) scale(${
                    inView ? 1 : 1
                  }) translate(-494.9, -355.2)`}
                  stroke={stroke}
                  strokeWidth="3"
                  cx="494.9"
                  cy="355.2"
                  r="76.3"
                ></circle>

                <circle
                  id="Oval"
                  className={s.transition}
                  transform={`translate(317.7, 355.2) scale(${
                    inView ? 1 : 1
                  }) translate(-317.7, -355.2)`}
                  stroke={stroke}
                  strokeWidth="3"
                  cx="317.7"
                  cy="355.2"
                  r="76.3"
                ></circle>

                <circle
                  id="Oval"
                  className={s.transition}
                  transform={`translate(406.3, 508.5) scale(${
                    inView ? 1 : 1
                  }) translate(-406.3, -508.5)`}
                  stroke={stroke}
                  strokeWidth="3"
                  cx="406.3"
                  cy="508.5"
                  r="76.3"
                ></circle>

                <circle
                  id="Oval"
                  className={s.transition}
                  transform={`translate(229.2, 508.5) scale(${
                    inView ? 1 : 1
                  }) translate(-229.2, -508.5)`}
                  stroke={stroke}
                  strokeWidth="3"
                  cx="229.2"
                  cy="508.5"
                  r="100.8"
                ></circle>

                <circle
                  id="Oval"
                  className={s.transition}
                  transform={`translate(583.4, 508.5) scale(${
                    inView ? 1 : 1
                  }) translate(-583.4, -508.5)`}
                  stroke={stroke}
                  strokeWidth="3"
                  cx="583.4"
                  cy="508.5"
                  r="100.8"
                ></circle>

                <circle
                  id="Oval"
                  className={s.transition}
                  transform={`translate(583.4, 508.5) scale(${
                    inView ? 1 : 1
                  }) translate(-583.4, -508.5)`}
                  stroke={stroke}
                  strokeWidth="3"
                  cx="583.4"
                  cy="508.5"
                  r="69"
                ></circle>

                <circle
                  id="Oval"
                  className={s.transition}
                  transform={`translate(406.3, 201.8) scale(${
                    inView ? 1 : 1
                  }) translate(-406.3, -201.8)`}
                  stroke={stroke}
                  strokeWidth="3"
                  cx="406.3"
                  cy="201.8"
                  r="69"
                ></circle>
                <circle
                  id="Oval"
                  className={s.transition}
                  transform={`translate(229.2, 508.5) scale(${
                    inView ? 1 : 1
                  }) translate(-229.2, -508.5)`}
                  stroke={stroke}
                  strokeWidth="3"
                  fillRule="nonzero"
                  cx="229.2"
                  cy="508.5"
                  r="69"
                ></circle>

                <path
                  d="M406,406 L406,609 M406,406 L582,305 M406,406 L230,305"
                  id="Shape"
                  className={s.transition}
                  transform={`translate(407, 407) scale(${
                    inView ? 1 : 1
                  }) translate(-407, -407)`}
                  stroke={stroke}
                  strokeWidth="3"
                ></path>

                <circle
                  className={s.transition}
                  id="Oval"
                  strokeWidth="6"
                  stroke={
                    slide >= 1
                      ? +slide === 1
                        ? "#0C5860"
                        : "#31989E"
                      : "transparent"
                  }
                  fill={slide >= 1 ? "#fff" : "transparent"}
                  fillRule="nonzero"
                  cx="229.2"
                  cy="508.5"
                  r="69"
                ></circle>

                <g
                  className={s.transition}
                  x="0"
                  y="0"
                  style={{
                    transform: `rotate(${Math.max(slide, 1) * -120 + 0.1}deg)`,
                    transformOrigin: `${229.2}px ${508.5}px`,
                  }}
                >
                  <text
                    id="Value"
                    className={s.transition}
                    fill={+slide < 1 ? stroke : "#474747"}
                    fillRule="nonzero"
                    fontFamily="Helvetica"
                    fontSize={process.env.REACT_APP_LANG !== "EN" ? 27 : 36}
                    fontWeight="normal"
                    text-anchor="middle"
                    alignment-baseline="middle"
                  >
                    <tspan x="229.2" y="521">
                      {copy.value}
                    </tspan>
                  </text>
                </g>
                <circle
                  className={s.transition}
                  id="Oval"
                  strokeWidth="6"
                  stroke={
                    slide >= 3
                      ? +slide === 3
                        ? "#DE2414"
                        : "#EE6047"
                      : "transparent"
                  }
                  fill={slide >= 3 ? "#fff" : "transparent"}
                  fillRule="nonzero"
                  cx="406.3"
                  cy="201.9"
                  r="68.2"
                ></circle>

                <g
                  className={s.transition}
                  style={{
                    transform: `rotate(${Math.max(slide, 1) * -120 + 0.1}deg)`,
                    transformOrigin: `${406.5}px ${201.9}px`,
                  }}
                  x="0"
                  y="0"
                >
                  <text
                    id="Trust"
                    className={s.transition}
                    fill={+slide < 3 ? stroke : "#474747"}
                    fillRule="nonzero"
                    fontFamily="Helvetica"
                    fontSize={process.env.REACT_APP_LANG !== "EN" ? 27 : 36}
                    fontWeight="normal"
                    text-anchor="middle"
                    alignment-baseline="middle"
                  >
                    <tspan x="406.3" y="214">
                      {copy.trust}
                    </tspan>
                  </text>
                </g>

                <circle
                  className={s.transition}
                  id="Oval"
                  strokeWidth="6"
                  stroke={
                    slide >= 2
                      ? +slide === 2
                        ? "#211633"
                        : "#5C4B72"
                      : "transparent"
                  }
                  fill={slide >= 2 ? "#fff" : "transparent"}
                  fillRule="nonzero"
                  cx="583.3"
                  cy="508.7"
                  r="68.2"
                ></circle>

                <g
                  className={s.transition}
                  style={{
                    transform: `rotate(${Math.max(slide, 1) * -120 + 0.1}deg)`,
                    transformOrigin: `${583.3}px ${508.7}px`,
                  }}
                  x="0"
                  y="0"
                >
                  <text
                    id="Equity"
                    className={s.transition}
                    fill={+slide < 2 ? stroke : "#474747"}
                    fillRule="nonzero"
                    fontFamily="Helvetica"
                    fontSize={process.env.REACT_APP_LANG !== "EN" ? 27 : 36}
                    fontWeight="normal"
                    text-anchor="middle"
                    // alignment-baseline="middle"
                  >
                    <tspan x="583.3" y="521">
                      {copy.equity}
                    </tspan>
                  </text>
                </g>
                <circle
                  id="Oval"
                  className={s.transition}
                  transform={`translate(407, 407) scale(${
                    inView ? 1 : 1
                  }) translate(-407, -407)`}
                  stroke={stroke}
                  strokeWidth="3"
                  cx="406.3"
                  cy="406.2"
                  r="406"
                ></circle>
              </g>
            </g>
          </svg>
        </div>

        <div className={s.scenes}>
          <Scrollama
            offset={0.75}
            onStepEnter={({ elem, data }) => {
              setVizProps(data);
            }}
          >
            {scenes.map((scene, i) => {
              return (
                <Step data={scene} index={i} key={`scene-${i}`}>
                  <div className={s.scene}>
                    <div className={s.text}>
                      {scene.title && (
                        <h3 className={s.title}>{scene.title}</h3>
                      )}
                      <p dangerouslySetInnerHTML={{ __html: scene.text }} />
                    </div>
                  </div>
                </Step>
              );
            })}
          </Scrollama>
        </div>
      </div>
    </div>
  );
};

export default Summary;
